"use client";
import { useState, useRef, useEffect } from "react";
import { useGlobalContext } from "../../../app/context/store";
import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import { isSDXL } from "../../shared/generators/isSDXL";
import { useGenerator } from "@/app/context/GeneratorContext";
import BatchToggleSet from "./batchToggleSet";
import ResToggleSet from "./resToggleSet";
import NegPromptToggleSet from "./negPromptToggleSet";
import AdherenceToggleSet from "./adherenceToggleSet";

export default function AdvancedToggleSet({ translations }: { translations: any }) {
  const { state, setCustomPrompt } = useGenerator();
  const { user } = useGlobalContext();
  const [open, setOpen] = useState(0);
  const [currentGeneratorId, setCurrentGeneratorId] = useState("");
  // const [helpfulTip, setHelpfulTip] = useState(true)
  // const [promptLength, setPromptLength] = useState(0);
  // const [negPromptLength, setNegPromptLength] = useState(0);
  // const [minValue, setMinValue] = useState(0.0);
  // const [maxValue, setMaxValue] = useState(6.0);
  // const [sliderValue, setSliderValue] = useState(0.0);
  const textAreaRef = useRef(null);
  //const textAreaRefNegative = useRef(null);

  // const adjustHeight = () => {
  //   if (!textAreaRef.current) return;
  //   //@ts-ignore
  //   textAreaRef.current.style.height = 'inherit'; // Reset height to recalculate
  //   //@ts-ignore
  //   textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`; // Set new height based on scroll height
  // };

  const adjustHeight = () => {
    if (!textAreaRef.current) return;
    //@ts-ignore
    textAreaRef.current.style.height = "inherit"; // Reset height to recalculate

    // Adjust height based on the content or placeholder
    // @ts-ignore
    textAreaRef.current.style.height = `${Math.max(
      // @ts-ignore
      textAreaRef.current.scrollHeight,
      120,
    )}px`; // Set a minimum height of 100px

    // Increase height if there is content
    if (state.customPrompt) {
      //@ts-ignore
      textAreaRef.current.style.height = `${Math.max(
        //@ts-ignore
        textAreaRef.current.scrollHeight,
        110,
      )}px`; // Set higher minimum height when there's content
    }
  };

  const handleOpen = (value: any) => {
    setOpen(open === value ? 0 : value);
  };

  const handleTextAreaChange = (e: any) => {
    const newText = e.target.value;
    // setPromptLength(newText.length);
    setCustomPrompt(newText);

    // Now, reset the height to "auto" to shrink it in case the content is reduced
    //@ts-ignore
    textAreaRef.current.style.height = "auto";

    // Then, set it to its scrollHeight
    //@ts-ignore
    // textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    adjustHeight();
  };

  // const handleTextAreaChangeNegative = (e: any) => {
  //   const newText = e.target.value;
  //   // setNegPromptLength(newText.length);
  //   setCustomNegative(newText);

  //   // Now, reset the height to "auto" to shrink it in case the content is reduced
  //   //@ts-ignore
  //   textAreaRefNegative.current.style.height = "auto";

  //   // Then, set it to its scrollHeight
  //   //@ts-ignore
  //   textAreaRefNegative.current.style.height = `${textAreaRefNegative.current.scrollHeight}px`;
  // };

  // const handleSliderChange = (event: any) => {
  //   setSliderValue(event.target.value);
  //   setCfgScale(event.target.value);
  //   // console.log("hi")
  // };

  useEffect(() => {
    if (currentGeneratorId !== state.selectedGenerator._id) {
      // setMaxValue(state.selectedGenerator.cfgU);
      // setSliderValue(state.selectedGenerator.cfgM);
      // setMinValue(state.selectedGenerator.cfgL);
      setCurrentGeneratorId(state.selectedGenerator._id);
    }
    adjustHeight();
  }, [
    state.customPrompt,
    state.selectedGenerator.frontend.cfgU,
    state.selectedGenerator.frontend.cfgM,
    state.selectedGenerator.frontend.cfgL,
  ]);

  // @ts-ignore
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    );
  }

  return (
    <div className="mb-4 sm:mb-0">
      <Accordion
        open={open === 1}
        icon={<Icon id={1} open={open} />}
        className="border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] pt-2 sm:rounded-bl-lg sm:rounded-br-lg " //md:px-4 px-2
      >
        <AccordionHeader
          onClick={() => handleOpen(1)}
          className={`border-b-0 px-5 pb-4 pt-2 text-sm text-white sm:px-2 md:px-4 ${
            open === 1 ? "text-white hover:!text-white" : ""
          }`}
        >
          {translations.advanced}
          {/* {user?.membership?.level !== -1 && (
            <div className="my-[-2px] ml-auto flex flex-row rounded-full bg-[#0772DD] px-2 py-[2px]">
              <Image
                className="my-auto mr-1 h-3 w-3"
                src={IS_MAIN_SITE ? "https://cdn6.imgpog.com/ruby.webp" : "https://cdn6.imgpog.com/diamond.webp"}
                alt="Gem"
                objectFit="contain"
                unoptimized
              />
              <div className="text-xs font-semibold">
                {Math.ceil((state.customPrompt + state.customNegative).length / 10) *
                  state.creditCost.promptCost}
              </div>
            </div>
          )} */}
        </AccordionHeader>
        <AccordionBody className="pb-2 pt-0 font-normal text-white">
          {!isSDXL(state.selectedGenerator.shortName || "style") && (
            <div className="mx-2 mb-4 flex flex-col rounded-md bg-[#0772DD] p-2 md:mx-4">
              <div>{translations.helpfulTipXPrompt}</div>
            </div>
          )}
          <div className="mx-2 my-2 md:mx-4 md:my-4">
            <textarea
              ref={textAreaRef}
              value={state.customPrompt}
              onChange={handleTextAreaChange}
              placeholder={
                true // user._id !== "none"
                  ? `${translations.placeHolderOne} \n\n${translations.example}:\nPurple hair, braided hairstyle, legs spread, missionary vaginal\n\n`
                  : translations.placeHolderTwo
              }
              // disabled={user._id === "none"}
              // readOnly={user._id === "none"}
              className={`auto-height-textarea w-full rounded-md border-[0.5px] border-[#3C3C3C] bg-[#303237] px-4 py-2 text-[16px] focus:border-[#3C3C3C] focus:ring-0`}
              rows={1} // Start with one row
              style={{ overflow: "hidden", resize: "none" }} // Prevent scrollbars and user resizing
              maxLength={1000}
            ></textarea>
          </div>

          <div className="ml-2 md:ml-4">
            <ResToggleSet type="image" translations={translations} />
            <BatchToggleSet translations={translations} />
            <NegPromptToggleSet translations={translations} />
            <AdherenceToggleSet translations={translations} />
          </div>

          <div className="my-4 mb-2 flex flex-col pl-[12px] sm:flex-row sm:space-x-2">
            <a
              href="https://www.createporn.com/blog/how-to-use-prompting-and-tags-more-effectively"
              target="_blank"
              rel="noopener noreferrer"
              className="mx-auto text-sm font-medium text-[#6CB4F4]"
            >
              {translations.promptingGuide}
            </a>
          </div>
        </AccordionBody>
      </Accordion>
    </div>
  );
}
